import { axiosConfig } from "@/utils/axiosConfig";
import { omniAxios } from "@/utils/axios";

// 用户账号安全操作记录列表
export function apiUserRegisterOcpc(params) {
  return omniAxios({
    url: axiosConfig.apiUserRegisterOcpcPath,
    method: "get",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    headers: {
      landUrl: window.location.hostname + window.location.pathname,
    },
    params,
  });
}

// 发送验证码
export function apiUserRegisterMobileCodeSem(params) {
  return omniAxios({
    url: axiosConfig.apiUserRegisterMobileCodeSemPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    isFormData: true,
    withCredentials: false,
    headers: {
      nowUrl: document.location.href,
    },
    params,
  });
}

// 验证验证码
export function apiUserRegisterCodeValidateSem(params) {
  return omniAxios({
    url: axiosConfig.apiUserRegisterCodeValidateSemPath,
    method: "get",
    apiType: axiosConfig.API_TYPE.USER,
    isFormData: true,
    withCredentials: true,
    params,
    headers: {
      nowUrl: document.location.href,
    },
  });
}

// 注册
export function apiUserRegisterSemNew(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserRegisterSemNewPath,
    headers: {
      nowUrl: document.location.href,
    },
    isFormData: true,
    method: "post",
    params,
  });
}
//完善信息
export function apiUserCompleteInfoSem(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserCompleteInfoSemPath,
    isFormData: true,
    method: "post",
    params,
  });
}
//调查问卷注册 apiUserRegisterSemQuestionnairePath
export function apiUserRegisterSemQuestionnaire(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserRegisterSemQuestionnairePath,
    headers: {
      nowUrl: document.location.href,
    },
    isFormData: false,
    method: "post",
    params,
  });
}
// 注册成功埋点
export function burypointRegisterMonitorUpdateRegisterCodePoint(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.api,
    url: axiosConfig.burypointRegisterMonitorUpdateRegisterCodePointPath,
    isFormData: true,
    method: "post",
    params,
  });
}

// 发送验证码（需滑块）
export function apiUserRegisterMobileCodeSlidingVerifySem(params) {
  return omniAxios({
    url: axiosConfig.apiUserRegisterMobileCodeSlidingVerifySemPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    isFormData: true,
    withCredentials: true,
    params,
    headers: {
      nowUrl: document.location.href,
    },
  });
}
// 验证验证码
export function apiUserRegisterVerifyMobileCodeSem(params) {
  return omniAxios({
    url: axiosConfig.apiUserRegisterVerifyMobileCodeSemPath,
    method: "get",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    isFormData: true,
    withCredentials: false,
    params,
  });
}
// 注册
export function apiUserCompleteRegisterSem(params) {
  return omniAxios({
    url: axiosConfig.apiUserCompleteRegisterSemPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    isFormData: true,
    withCredentials: false,
    headers: {
      nowUrl: document.location.href,
    },
    params,
  });
}
// 登录获取验证码
export function apiUserLoginVerifyMobileCodeSem(params) {
  return omniAxios({
    url: axiosConfig.apiUserLoginVerifyMobileCodeSemPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    isFormData: true,
    withCredentials: false,
    params,
    headers: {
      nowUrl: document.location.href,
    },
  });
}
// 登录
export function apiUserCompleteLoginSem(params) {
  return omniAxios({
    url: axiosConfig.apiUserCompleteLoginSemPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    isFormData: true,
    withCredentials: false,
    params,
    headers: {
      nowUrl: document.location.href,
    },
  });
}

// 模板8列表请求
export function apiTem8DataList(params) {
  return omniAxios({
    url: axiosConfig.apiTem8DataListPath,
    method: "get",
    apiType: axiosConfig.API_TYPE.OSS,
    useDevServerProxy: true,
    params,
    headers: {
      "If-Modified-Since": "0",
      "Cache-Control": "no-cache",
    },
  });
}
// 模板2列表
export function getTempleteTwoList() {
  return omniAxios({
    url: axiosConfig.getTempleteTwoPath,
    method: "get",
    apiType: axiosConfig.API_TYPE.API,
    useDevServerProxy: true,
    withCredentials: false,
  });
}
// 公共埋点接口
export function burypointEventCollect(params) {
  return omniAxios({
    url: axiosConfig.burypointEventCollectPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.API,
    useDevServerProxy: true,
    withCredentials: false,
    params,
  });
}
export function burypointBehaviorInsertRecordFromSearchEngines(params) {
  return omniAxios({
    url: axiosConfig.burypointBehaviorInsertRecordFromSearchEnginesPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.API,
    useDevServerProxy: true,
    withCredentials: false,
    params,
  });
}
export function burypointQuestionnaireShowstatus(params) {
  return omniAxios({
    url: axiosConfig.burypointQuestionnaireShowstatusPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.API,
    useDevServerProxy: true,
    withCredentials: false,
    params,
  });
}

// 跳转到通讯录
export function apiUserCpLink(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserCpLinkPath,
    method: "post",
    params,
    useDevServerProxy: false,
  });
}

// 不注册发送短信
export function apiUserRegisterPhonecode(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserRegisterPhonecodePath,
    method: "post",
    params,
    isFormData: true,
    useDevServerProxy: false,
  });
}
// 不注册验证短信码
export function apiUserRegisterPhonecodeValidate(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserRegisterPhonecodeValidatePath,
    method: "get",
    params,
    useDevServerProxy: false,
    headers: {
      nowUrl: document.location.href,
    },
  });
}
// 保存问卷信息
export function apiUserRegisterSemQuestionnaireSave(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserRegisterSemQuestionnaireSavePath,
    method: "post",
    params,
    useDevServerProxy: false,
  });
}

// 模版调研用的 apiUserRegisterTestpageMobileCodePath
export function apiUserRegisterTestpageMobileCode(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserRegisterTestpageMobileCodePath,
    method: "post",
    params,
    useDevServerProxy: false,
    isFormData: true,
  });
}
//apiUserRegisterTestpageRegistPath
export function apiUserRegisterTestpageRegist(params) {
  return omniAxios({
    apiType: axiosConfig.API_TYPE.USER,
    url: axiosConfig.apiUserRegisterTestpageRegistPath,
    method: "post",
    params,
    useDevServerProxy: false,
    isFormData: true,
  });
}

// SEM标讯搜索接口
export function apiSemSearch(params) {
  return omniAxios({
    url: axiosConfig.apiSemSearchPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.API,
    useDevServerProxy: true,
    params,
    isFormData: true,
  });
}

//模板19apiSemKeywordSearchPath
export function apiSemKeywordSearch(params) {
  return omniAxios({
    url: axiosConfig.apiSemKeywordSearchPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.API,
    useDevServerProxy: true,
    params,
    isFormData: true,
  });
}
//最新的获取验证码 apiUserRegisterMobileCodeSemNewPath
export function apiUserRegisterMobileCodeSemNew(params) {
  return omniAxios({
    url: axiosConfig.apiUserRegisterMobileCodeSemNewPath,
    method: "post",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    isFormData: true,
    params,
    headers: {
      nowUrl: document.location.href,
    },
  });
}
//新的验证接口apiUserRegisterCodeValidateSemNewPath
export function apiUserRegisterCodeValidateSemNew(params) {
  return omniAxios({
    url: axiosConfig.apiUserRegisterCodeValidateSemNewPath,
    method: "get",
    apiType: axiosConfig.API_TYPE.USER,
    useDevServerProxy: false,
    // isFormData: true,
    params,
    headers: {
      nowUrl: document.location.href,
    },
  });
}
